exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-3536c674]{list-style-type:none;padding-left:0}ul li[data-v-3536c674]{display:block}ul li a[data-v-3536c674]{padding:4px 0;color:#000;text-decoration:none;text-transform:uppercase}ul li a.active[data-v-3536c674],ul li a[data-v-3536c674]:hover{color:var(--main-color)}ul li a:not(.active)~ul[data-v-3536c674]{display:none}ul li ul li[data-v-3536c674]{padding-left:10px}ul li ul li a[data-v-3536c674]{text-transform:none}", ""]);

// exports
